@use '@lib/assets/styles/main.scss' as *;

@keyframes fade {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.root {
  position: relative;
  display: grid;
  height: 100%;
}

.rootInline {
  display: inline-flex;
}

.overlayWrap {
  z-index: -1;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.overlayWrapVisible {
  z-index: 2;
  opacity: 1;
}

.overlay {
  z-index: 2;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.overlayDefault {
  background-color: $gray10;
  border-radius: 10px;
  border: 1px solid $gray200;
  opacity: .5;
}

.loader {
  z-index: 3;
}

.loaderIsCentered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.loaderIsPressedToTop {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
}

.content {
  width: 100%;
  min-width: 0;
  position: relative;
  z-index: 1;
}

.contentBlur {
  @extend %disabledGrayscale;
}

.desc {
  padding-top: 4px;
  text-align: center;
}
